import { render, staticRenderFns } from "./GradientButton.vue?vue&type=template&id=0fcca22e&scoped=true"
import script from "./GradientButton.vue?vue&type=script&lang=js"
export * from "./GradientButton.vue?vue&type=script&lang=js"
import style0 from "./GradientButton.vue?vue&type=style&index=0&id=0fcca22e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcca22e",
  null
  
)

export default component.exports